import styled from "styled-components";

export const EditAutomationPanelStyles = styled.div.attrs({
  className: "cl-conditions-container",
})`
  margin-bottom: 24px;

  /* Container for the condition rows' responsive layout: each ConditionItem
     switches between the inline and stacked layouts based on THIS element's
     width. The @container query lives in ConditionItem/conditions-responsive.css
     (styled-components' stylis can't emit @container correctly); the
     cl-conditions-container class is its specificity anchor. Replaces the old
     \`stacked\` boolean prop -- one layout, width-driven. */
  container-type: inline-size;
  container-name: cl-conditions;

  .icon-text-button {
    padding: 0;
  }
`;
